module.exports = __webpack_public_path__ + "fonts/icomoon.e3e5185.ttf";